<script lang="ts">
  import { onlineManager, focusManager } from "@tanstack/svelte-query";
  import { notify } from "services/notifications";
  import { onlineState } from "../../state/page";

  onlineManager.setEventListener(() => {
    let onlineTimeout: ReturnType<typeof setTimeout> | null = null;

    function handleOnline() {
      // Clear any existing timeout to debounce rapid events
      if (onlineTimeout) {
        clearTimeout(onlineTimeout);
        onlineTimeout = null;
      }

      // Debounce the online event to prevent multiple notifications
      onlineTimeout = setTimeout(() => {
        if ($onlineState === "OFFLINE") {
          document.getElementById("offline")?.remove();
          notify("Du er nå tilbake på nett", "success", 3000, "online");
          onlineState.set("ONLINE");
          focusManager.setFocused(true);
        }
        onlineTimeout = null;
      }, 100); // 100ms debounce delay
    }
    function handleOffline() {
      if (onlineTimeout) {
        clearTimeout(onlineTimeout);
        onlineTimeout = null;
      }

      notify(
        "Det ser ut som du har mistet tilgang til Internett. Bildebanken vil ikke fungere uten nett",
        "warning",
        50000,
        "offline",
      );
      onlineState.set("OFFLINE");
      focusManager.setFocused(undefined);
    }

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      if (onlineTimeout) {
        clearTimeout(onlineTimeout);
        onlineTimeout = null;
      }

      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  });
</script>
